import { Typography } from '@material-ui/core';
import React from 'react';

export function GraphResponseTimeInfo(props) {
  const showInfo = () => {
    let oldDate = new Date(props.x);
    let year = oldDate.getUTCFullYear();
    let month = oldDate.getUTCMonth();
    let day = oldDate.getUTCDate();
    let hours = oldDate.getUTCHours();
    let minutes = oldDate.getUTCMinutes();
    let seconds = oldDate.getUTCSeconds();

    let newDate = new Date(year, month, day, hours, minutes, seconds);
    return {
      nameStep: props.step,
      x: newDate.toLocaleString([], { hour12: false }),
      y: props.y,
    };
  };

  if (!props.x) {
    return null;
  }

  const { nameStep, x, y } = showInfo();

  return (
    <Typography
      style={{
        fontSize: '13px',
        float: 'left',
        paddingLeft: '5px',
        color: '#66788A',
      }}
    >
      <h3>{nameStep}</h3>
      <h1>{y}(s)</h1>
      <h5>{x}</h5>
    </Typography>
  );
}
